import { FC } from "react";
import { Box } from "@mui/material";

import Loading from "../../assets/Loading.gif";

import "./index.css";

interface IPropsStepLoader {}

const StepLoader: FC<IPropsStepLoader> = () => (
  <>
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        marginTop: "50px",
        marginBottom: "120px",
      }}
    >
      <img
        src={Loading}
        alt="Loading"
        style={{ width: "259px", height: "259px" }}
      />
    </Box>
  </>
);

export default StepLoader;
